// A command typed in a chat that has no bot arrives as plain text: Telegram marks it only where a bot can
// read it. Inside a right-to-left sentence its slash is a neutral character and takes the sentence's
// direction, so `/start` reads as `start/`. These are the words that are drawn in an isolate of their own;
// nothing in the text itself changes.
//
// A command word starts at the beginning of the text or after a space, and ends at the end of the text, at
// a space or at a sentence mark. So `/start` and `/start@LiveBot` are, and a path, a date or a link is not.
// The space before the word is matched, not looked behind for: Safari before 16.4 cannot parse a look-behind,
// and this module is on the path of every message
const COMMAND_WORD = /(^|\s)(\/[A-Za-z0-9_]{1,64}(?:@[A-Za-z0-9_]{3,32})?)(?=$|[\s.,!?؟،؛:;])/g;

export function findCommandWords(text: string): { start: number; end: number }[] {
  if (!text.includes('/')) return [];

  return [...text.matchAll(COMMAND_WORD)].map((match) => {
    const start = match.index + match[1].length;
    return { start, end: start + match[2].length };
  });
}
